import * as React from 'react';
import { SvgIcon, SvgIconBaseProps } from '../components/SvgIcon/SvgIcon';

export function StarFilledIcon(props: SvgIconBaseProps): React.JSX.Element {
    return (
        <SvgIcon {...props} viewBox="0 0 50 50">
            <path d="M23.489 5.018a1.635 1.635 0 0 1 3.029 0l4.864 11.946 13.13 1.158a1.635 1.635 0 0 1 .896 2.888l-8.995 7.442a1.635 1.635 0 0 0-.557 1.603l2.807 13.077a1.636 1.636 0 0 1-2.512 1.701L25.003 37.33l-11.148 7.503a1.636 1.636 0 0 1-2.512-1.7l2.807-13.078a1.636 1.636 0 0 0-.556-1.603L4.592 21.01a1.635 1.635 0 0 1 .9-2.888l13.126-1.158 4.87-11.946Z" />
        </SvgIcon>
    );
}
